import { useLiveQuery } from 'dexie-react-hooks';
import { pendingScanRepository } from '@/db/repositories/pendingScanRepository';

export interface LocalScanStats {
  pending: number;
  uploadedSuccessfully: number;
  failed: number;
  scannedToday: number;
}

/**
 * useLiveQuery re-runs automatically whenever the underlying Dexie tables it
 * reads from change -- so as the sync engine (Stage 9) marks scans uploaded
 * in the background, these numbers update on screen with no manual refetch
 * or polling, which matters for the "battery friendly" dashboard requirement.
 */
export function useLocalScanStats(): LocalScanStats | undefined {
  return useLiveQuery(async () => ({
    pending: await pendingScanRepository.countPending(),
    uploadedSuccessfully: await pendingScanRepository.countUploadedSuccessfully(),
    failed: await pendingScanRepository.countFailed(),
    scannedToday: await pendingScanRepository.countScannedToday()
  }));
}
